import { MapPin } from 'lucide-react';
import SavedBranchesCard from '../../components/manager/SavedBranchesCard';

/**
 * Branches — Phase 1 UX correction.
 * Lightweight page that reuses the existing SavedBranchesCard (same
 * component used inside Profile). Gives "More → Branches" a first-class
 * landing page with a clear "Manage Branches" heading, rather than
 * dropping the manager into the middle of Profile.
 */
export default function ManagerBranchesPage() {
  return (
    <div className="p-4 sm:p-6 max-w-3xl mx-auto pb-32 lg:pb-8" data-testid="manager-branches-page">
      <div className="flex items-center gap-3 mb-6">
        <div className="h-11 w-11 rounded-2xl bg-[#4338CA]/10 flex items-center justify-center shrink-0">
          <MapPin className="h-5 w-5 text-[#4338CA]" />
        </div>
        <div>
          <h1 className="text-2xl font-bold text-slate-900 font-['Public_Sans']">Manage Branches</h1>
          <p className="text-[14px] text-slate-500">Save the branches you cover so posting a shift is one-tap.</p>
        </div>
      </div>
      <SavedBranchesCard />
    </div>
  );
}
